import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
 * Hero class.
 */
export default class VideoHero extends withIntersectionObserver(Base) {
  isVisible = false;

  /**
   * Class config
   * @returns {object}
   */
  static config() {
    return {
      name: 'VideoHero',
    };
  }

  /**
   * Mount component
   */
  mounted() {
    this.hero = document.querySelector('#hero');

    setTimeout(() => {
      if (!this.isVisible) {
        this.$el.play();
        this.isVisible = true;
      }
    }, 2000);

    if (this.hero) {
      this.hero.addEventListener('click', () => {
        this.$el.play();
        this.isVisible = true;
      });
    }
  }

  /**
   * Click on video
   */
  onClick() {
    if (!this.isVisible) {
      this.$el.play();
      this.isVisible = true;
    }
  }

  /**
   * Scroll element
   */
  scrolled() {
    if (!this.isVisible) {
      console.log('scrolled');
      this.$el.play();
      this.isVisible = true;
      console.log('scrolled');
    }
  }

  /**
   * Triggered when the root element of the component is intersecting.
   * @param  {Array<IntersectionObserverEntry>} entries
   */
  intersected([entry]) {
    if (entry.isIntersecting && !this.isVisible) {
      this.isVisible = true;
      this.$el.play();
    }
  }
}
